import UserReviews from './components/UserReviews';
import { AiToolsList } from '../LandingPage';
import HeroSection from '../LandingPage/components/HeroSection';
import ProductDescription from '../LandingPage/components/ProductDescription';
import MainImage from '~/assets/main.png';
import dayjs from 'dayjs';

function BlogPostView({ title, htmlContent, updatedDateTimeIsoString }) {
    return (
        <section className='py-12 bg-white sm:py-16 lg:py-20'>
            <div className='px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='max-w-3xl mx-auto xl:max-w-4xl'>
                    <p className='text-sm font-bold tracking-widest text-gray-400 uppercase font-pj'>
                        Blog
                    </p>
                    <h1 className='text-3xl font-bold text-gray-900 mt-7 sm:text-4xl xl:text-5xl font-pj'>
                        {title}
                    </h1>
                    <p className='text-sm font-normal text-gray-600 mt-7 font-pj'>
                        {dayjs(updatedDateTimeIsoString)
                            .format('DD MMMM, YYYY')
                            .toString()}
                    </p>

                    <div className='mt-10'>
                        <svg
                            className='w-auto h-4 text-gray-300'
                            width='172'
                            height='16'
                            viewBox='0 0 172 16'
                            fill='none'
                            stroke='currentColor'
                            xmlns='http://www.w3.org/2000/svg'>
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 11 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 46 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 81 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 116 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 151 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 18 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 53 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 88 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 123 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 158 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 25 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 60 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 95 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 130 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 165 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 32 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 67 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 102 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 137 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 172 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 39 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 74 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 109 1)'
                            />
                            <line
                                y1='-0.5'
                                x2='18.0278'
                                y2='-0.5'
                                transform='matrix(-0.5547 0.83205 0.83205 0.5547 144 1)'
                            />
                        </svg>
                    </div>

                    <article
                        className='mt-10 prose lg:prose-xl'
                        dangerouslySetInnerHTML={{
                            __html: htmlContent,
                        }}></article>
                </div>
            </div>
        </section>
    );
}

export default function Index({
    title,
    htmlContent,
    updatedDateTimeIsoString,
}) {
    return (
        <>
            <BlogPostView
                title={title}
                htmlContent={htmlContent}
                updatedDateTimeIsoString={updatedDateTimeIsoString}
            />
        </>
    );
}
